import React, { PureComponent } from 'react'
import { string, arrayOf, object } from 'prop-types'
import Helmet from 'react-helmet'

class Head extends PureComponent {
  render() {
    const { seoHTMLTitle, seoMetadata, seoHTMLMetaDescription, keywords, tags } = this.props

    return (
      <Helmet>
        {seoHTMLTitle && <title>{seoHTMLTitle}</title>}
        {seoHTMLMetaDescription && <meta name="description" content={seoHTMLMetaDescription} />}
        {seoMetadata && <meta name="robots" content={seoMetadata.robotsHtml} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {tags && tags.map(({ name, text }) => <meta name={name} content={text} key={name + text} />)}
      </Helmet>
    )
  }
}

Head.propTypes = {
  seoHTMLTitle: string,
  seoHTMLMetaDescription: string,
  keywords: string,
  tags: arrayOf(object)
}

Head.defaultProps = {
  seoHTMLTitle: null,
  seoHTMLMetaDescription: null,
  keywords: null,
  tags: null
}

export default Head
